import type { ColumnDef } from "@tanstack/react-table";
import { buildTagColumn } from "@/components/Table";
import type { TagType } from "@/components/Tag/Tag";
import { renderEmptyCellState } from "@/components/Table/utils";
import { toFormat } from "@/lib/dateHelpers";
import { formatEnumLabel } from "@/pages/billing/finance/commission/_utils";
import type { PersonGrpIaaRow } from "../types";

function iaaStatusType(status: PersonGrpIaaRow["status"]): TagType {
  if (status === "ACTIVE") return "success";
  if (status === "ENDED") return "surface";
  return "warn";
}

export function getIaaColumns(): ColumnDef<PersonGrpIaaRow, unknown>[] {
  return [
    {
      id: "facility",
      accessorFn: (row) => row.facilityName,
      header: "Facility",
      size: 200,
      enableSorting: false,
      cell: ({ row }) => renderEmptyCellState(row.original.facilityName)
    },
    {
      accessorKey: "receiverPgaId",
      header: "Receiver PGA ID",
      size: 140,
      enableSorting: false,
      cell: ({ row }) => renderEmptyCellState(row.original.receiverPgaId)
    },
    {
      id: "split",
      accessorFn: (row) => row.splitPercent,
      header: "Split",
      size: 80,
      enableSorting: false,
      cell: ({ row }) => renderEmptyCellState(`${row.original.splitPercent}%`)
    },
    buildTagColumn<PersonGrpIaaRow>({
      accessorKey: "status",
      header: "Status",
      size: 120,
      getTagLabel: (row) => formatEnumLabel(row.status),
      getTagType: (row) => iaaStatusType(row.status),
      getTagStyle: () => "strong"
    }),
    {
      accessorKey: "effectiveDate",
      header: "Effective",
      size: 120,
      cell: ({ row }) => renderEmptyCellState(toFormat(row.original.effectiveDate))
    }
  ];
}
